module.exports = __webpack_public_path__ + "static/media/layerofonions.fc145387.svg";